export const Bindings = {
	JSONProvider: Symbol("JSONProvider"),
	AuthApiProvider: Symbol("AuthApiProvider"),
	ApiHTTPClient: Symbol("ApiHTTPClient"),
	UserApiProvider: Symbol("UserApiProvider"),
	TeamApiProvider: Symbol("TeamApiProvider"),
	PasswordApiProvider: Symbol("PasswordApiProvider"),
	JsonHTTPClient: Symbol("JsonHTTPClient"),
	ContentJsonHTTPClient: Symbol("ContentJsonHTTPClient"),
	CountriesStore: Symbol("CountriesStore"),
	StatesStore: Symbol("StatesStore"),
	RoundsStore: Symbol("RoundsStore"),
	PlayersStore: Symbol("PlayersStore"),
	SquadsStore: Symbol("SquadsStore"),
	UserStore: Symbol("UserStore"),
	LocalizationStore: Symbol("LocalizationStore"),
	LocalizationController: Symbol("LocalizationController"),
	StaticContentStore: Symbol("StaticContentStore"),
	ModalsStore: Symbol("ModalsStore"),
	TeamStore: Symbol("TeamStore"),
	PlayerPoolStore: Symbol("PlayerPoolStore"),
	ShareStore: Symbol("ShareStore"),
	PoolController: Symbol("PoolController"),
	PoolModalController: Symbol("PoolModalController"),
	AuthController: Symbol("AuthController"),
	LoginController: Symbol("LoginController"),
	RegistrationController: Symbol("RegistrationController"),
	MyAccountController: Symbol("MyAccountController"),
	SecretGateController: Symbol("SecretGateController"),
	HelpController: Symbol("HelpController"),
	HelpListController: Symbol("HelpListController"),
	ContactUsController: Symbol("ContactUsController"),
	ChecksumStore: Symbol("ChecksumStore"),
	LiveScoreController: Symbol("LiveScoreController"),
	GlobalModalsController: Symbol("GlobalModalsController"),
	ModalsController: Symbol("ModalsController"),
	ForgotPasswordController: Symbol("ForgotPasswordController"),
	ResetPasswordController: Symbol("ResetPasswordController"),
	SessionController: Symbol("SessionController"),
	BootstrapController: Symbol("BootstrapController"),
	GameController: Symbol("GameController"),
	MenuController: Symbol("MenuController"),
	HeaderController: Symbol("HeaderController"),
	CookieBannerController: Symbol("CookieBannerController"),
	LandingController: Symbol("LandingController"),
	PlayerSlotController: Symbol("PlayerSlotController"),
	GameBarController: Symbol("GameBarController"),
	StepperController: Symbol("StepperController"),
	SavedPlayerSlotController: Symbol("SavedPlayerSlotController"),
	PromptModalController: Symbol("PromptModalController"),
	PlayerTooltipController: Symbol("PlayerTooltipController"),
	ShareController: Symbol("ShareController"),
};
